var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.565 16.783a5.217 5.217 0 1 0 10.435 0 5.217 5.217 0 0 0-10.435 0zM13.094 20.471l7.378-7.378",
    stroke: "#E95454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.391 5.696a3.696 3.696 0 1 0 7.392 0 3.696 3.696 0 0 0-7.392 0zM2 16.783a6.087 6.087 0 0 1 9.377-5.122M6.5 5V3M9.5 5V3M3 5.5h10.5",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 11.5a2.5 2.5 0 0 0 5 0M4.5 12.5V17",
    stroke: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBan);
export default __webpack_public_path__ + "static/media/iconBan.9cb510aceb4cf02c0aa3fa568e6f2062.svg";
export { ForwardRef as ReactComponent };